/**
 * load chapter data on load
 * and create global promise which returns the chapters in order
 */
const loadChapterData = ( async () => {
	sessionStorage.removeItem( 'chapters' );
	return getChapterData();
	// let chapters = JSON.parse( sessionStorage.getItem( 'chapters' ) );
	// chapters = false; // turn off caching
	// if ( chapters ) {
	// 	return chapters;
	// }
	// await putChaptersInStorage();
	// return JSON.parse( sessionStorage.getItem( 'chapters' ) );
} )();


async function putChaptersInStorage() {
	const chapters = JSON.stringify( await getChapterData() );
	sessionStorage.setItem( 'chapters', chapters );
	return;
}
async function getChapterData() {
	const params = new URLSearchParams( {
		orderby: 'menu_order',
		order: "asc",
		per_page: "100"
	} )
	const resp = await fetch( `/wp-json/wp/v2/chapter?${params.toString()}`, {
		cache: 'default' // default, no-store
	} )
		.catch( ( err ) => {
			console.error( 'JSON Fetch Error', err.message )
		} );
	return await resp.json();
}

